import axios from 'axios';

/**
 * 言語ごとの月表記の一覧。
 * ブラウザごとに表記が異なるため、ANAさま確認済みの表記を一覧化している。
 */
const months = {
  en: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  },
  ja: {
    1: '1月',
    2: '2月',
    3: '3月',
    4: '4月',
    5: '5月',
    6: '6月',
    7: '7月',
    8: '8月',
    9: '9月',
    10: '10月',
    11: '11月',
    12: '12月',
  },
  ko: {
    1: '1월',
    2: '2월',
    3: '3월',
    4: '4월',
    5: '5월',
    6: '6월',
    7: '7월',
    8: '8월',
    9: '9월',
    10: '10월',
    11: '11월',
    12: '12월',
  },
  cn: {
    1: '1月',
    2: '2月',
    3: '3月',
    4: '4月',
    5: '5月',
    6: '6月',
    7: '7月',
    8: '8月',
    9: '9月',
    10: '10月',
    11: '11月',
    12: '12月',
  },
  tw: {
    1: '1月',
    2: '2月',
    3: '3月',
    4: '4月',
    5: '5月',
    6: '6月',
    7: '7月',
    8: '8月',
    9: '9月',
    10: '10月',
    11: '11月',
    12: '12月',
  },
  de: {
    1: 'Januar',
    2: 'Februar',
    3: 'März',
    4: 'April',
    5: 'Mai',
    6: 'Juni',
    7: 'Juli',
    8: 'August',
    9: 'September',
    10: 'Oktober',
    11: 'November',
    12: 'Dezember',
  },
  fr: {
    1: 'janvier',
    2: 'février',
    3: 'mars',
    4: 'avril',
    5: 'mai',
    6: 'juin',
    7: 'juillet',
    8: 'août',
    9: 'septembre',
    10: 'octobre',
    11: 'novembre',
    12: 'décembre',
  },
  th: {
    1: 'มกราคม',
    2: 'กุมภาพันธ์',
    3: 'มีนาคม',
    4: 'เมษายน',
    5: 'พฤษภาคม',
    6: 'มิถุนายน',
    7: 'กรกฎาคม',
    8: 'สิงหาคม',
    9: 'กันยายน',
    10: 'ตุลาคม',
    11: 'พฤศจิกายน',
    12: 'ธันวาคม',
  },
  id: {
    1: 'Januari',
    2: 'Februari',
    3: 'Maret',
    4: 'April',
    5: 'Mei',
    6: 'Juni',
    7: 'Juli',
    8: 'Agustus',
    9: 'September',
    10: 'Oktober',
    11: 'November',
    12: 'Desember',
  },
  hk: {
    1: '1月',
    2: '2月',
    3: '3月',
    4: '4月',
    5: '5月',
    6: '6月',
    7: '7月',
    8: '8月',
    9: '9月',
    10: '10月',
    11: '11月',
    12: '12月',
  },
  vi: {
    1: 'tháng 1',
    2: 'tháng 2',
    3: 'tháng 3',
    4: 'tháng 4',
    5: 'tháng 5',
    6: 'tháng 6',
    7: 'tháng 7',
    8: 'tháng 8',
    9: 'tháng 9',
    10: 'tháng 10',
    11: 'tháng 11',
    12: 'tháng 12',
  },
};

/**
 * 言語と国以降のURLを取得する（パラメーターとハッシュを除く）
 * @return {string}
 */
const getJTPUrl = () => {
  const pathnameArray = window.location.pathname.split('/');
  pathnameArray.splice(0, 3);
  return `/${pathnameArray.join('/')}`;
};

/**
 * 言語を取得する
 * @return {string}
 */
export const getLang = () => {
  const pathnameArray = window.location.pathname.split('/');
  pathnameArray.splice(0, 1);
  return String(pathnameArray[0]);
};

/**
 * 国を取得する
 * @return {string}
 */
export const getCountry = () => {
  const pathnameArray = window.location.pathname.split('/');
  pathnameArray.splice(0, 2);
  return String(pathnameArray[0]);
};

/**
 * 言語・年・月を受け取り、整形済みの文字列（年月）を返します。
 * @param {String} lang en,ja,ko,cn,tw,de,fr,th,id,hk,viのいずれか
 * @param {Number} year
 * @param {Number} month
 * @returns
 */
const formatYearMonth = (lang, year, month) => {
  if (lang === 'en') {
    return `${months.en[month]} ${year}`;
  }
  if (lang === 'ja') {
    return `${year}年${months.ja[month]}`;
  }
  if (lang === 'ko') {
    return `${year}년 ${months.ko[month]}`;
  }
  if (lang === 'cn') {
    return `${year}年${months.cn[month]}`;
  }
  if (lang === 'tw') {
    return `${year}年${months.tw[month]}`;
  }
  if (lang === 'de') {
    return `${months.de[month]} ${year}`;
  }
  if (lang === 'fr') {
    return `${months.fr[month]} ${year}`;
  }
  if (lang === 'th') {
    return `${months.th[month]} ${year}`;
  }
  if (lang === 'id') {
    return `${months.id[month]} ${year}`;
  }
  if (lang === 'hk') {
    return `${year}年${months.hk[month]}`;
  }
  if (lang === 'vi') {
    return `${months.vi[month]} năm ${year}`;
  }

  return `${months.en[month]} ${year}`;
};

/**
 * 言語ごとに出力する文言を整形する。
 * @param {string} lang
 * @param {number} year
 * @param {number} month
 * @return {string}
 */
const getLangFormat = (lang, country, year, month) => {
  if (lang === 'en') {
    return `The information on this webpage is as of ${formatYearMonth('en', year, month)}.`;
  }

  if (lang === 'ja') {
    return `掲載している情報は${formatYearMonth('ja', year, month)}時点の情報です。`;
  }

  if (lang === 'ko') {
    return `이 페이지에 게재된 정보는 ${formatYearMonth('ko', year, month)} 시점의 정보입니다.`;
  }

  if (lang === 'zh' && country === 'cn') {
    return `本页登载的信息截至${formatYearMonth('cn', year, month)}。`;
  }

  if (lang === 'zh' && country === 'tw') {
    const langDate = formatYearMonth('tw', year, month)
      .replace('年', ' 年 ')
      .replace('月', ' 月');
    return `此頁面記載之內容為 ${langDate}當下的資訊。`;
  }

  if (lang === 'de') {
    return `Die Informationen auf dieser Webseite sind vom ${formatYearMonth('de', year, month)}.`;
  }

  if (lang === 'fr') {
    return `Les informations figurant sur cette page internet ont été mises à jour en ${formatYearMonth(
      'fr',
      year,
      month,
    )}.`;
  }

  if (lang === 'th') {
    return `ข้อมูลในหน้าเว็บนี้เป็นข้อมูล ณ เดือน${formatYearMonth('th', year, month)}`;
  }

  if (lang === 'id') {
    return `Informasi pada halaman web ini diperbarui pada bulan ${formatYearMonth(
      'id',
      year,
      month,
    )}.`;
  }

  if (lang === 'zh' && country === 'hk') {
    const langDate = formatYearMonth('hk', year, month)
      .replace('年', ' 年 ')
      .replace('月', ' 月');
    return `此頁面的資訊最後更新日期為 ${langDate}。`;
  }

  if (lang === 'vi') {
    return `Thông tin trên trang web này là thông tin hiện hành từ ${formatYearMonth(
      'vi',
      year,
      month,
    )}.`;
  }

  return `The information on this webpage is as of ${formatYearMonth('en', year, month)}.`;
};

/**
 * 更新対象ディレクトリならJSONデータを、対象外なら`false`を返す
 * @return {object | false}
 */
const getUpdateData = async directory => {
  const dir = directory;
  const data = await axios
    .get(`/japan-travel-planner/common/js/update-date.json`)
    .then(response => {
      return response.data;
    });

  const findDirectory = data.find(arr => {
    return arr.directory === dir;
  });

  return findDirectory;
};

/**
 * 更新日を出力する
 * @return {void}
 */
const v1RenderUpdateDate = async () => {
  const url = getJTPUrl();
  const lang = getLang();
  const country = getCountry();
  // JSONから更新年月を取得する
  const updateData = await getUpdateData(url);

  // 更新対象外ページの場合は処理を中止する
  if (!updateData) {
    return;
  }

  const text = getLangFormat(lang, country, updateData.year, updateData.month);
  const insertElement = document.querySelector('.v1-footer');
  insertElement.insertAdjacentHTML(
    'afterbegin',
    `<div class="v1-footer__update"><p class="v1-footer__updateText">${text}</p></div>`,
  );
};

export default function v1UpdateData() {
  v1RenderUpdateDate();
}

/**
 * 言語ごとのフォーマット結果をすべてブラウザとコンソールに出力します。
 */
/* eslint-disable no-unused-vars, no-console */
const testLangFormat = () => {
  // `1`から始まる配列を生成する
  const getNumberedArray = num => {
    return [...Array(num)].map((_, i) => i + 1);
  };

  const insertElement = document.querySelector('.v1-footer');

  getNumberedArray(12).forEach(item => {
    insertElement.insertAdjacentHTML(
      'beforeend',
      `<div>${getLangFormat('en', 'us', 2021, item)}</div>`,
    );
  });
  getNumberedArray(12).forEach(item => {
    insertElement.insertAdjacentHTML(
      'beforeend',
      `<div>${getLangFormat('ja', 'jp', 2021, item)}</div>`,
    );
  });
  getNumberedArray(12).forEach(item => {
    insertElement.insertAdjacentHTML(
      'beforeend',
      `<div>${getLangFormat('ko', 'kr', 2021, item)}</div>`,
    );
  });
  getNumberedArray(12).forEach(item => {
    insertElement.insertAdjacentHTML(
      'beforeend',
      `<div>${getLangFormat('zh', 'cn', 2021, item)}</div>`,
    );
  });
  getNumberedArray(12).forEach(item => {
    insertElement.insertAdjacentHTML(
      'beforeend',
      `<div>${getLangFormat('zh', 'tw', 2021, item)}</div>`,
    );
  });
  getNumberedArray(12).forEach(item => {
    insertElement.insertAdjacentHTML(
      'beforeend',
      `<div>${getLangFormat('de', 'de', 2021, item)}</div>`,
    );
  });
  getNumberedArray(12).forEach(item => {
    insertElement.insertAdjacentHTML(
      'beforeend',
      `<div>${getLangFormat('fr', 'fr', 2021, item)}</div>`,
    );
  });
  getNumberedArray(12).forEach(item => {
    insertElement.insertAdjacentHTML(
      'beforeend',
      `<div>${getLangFormat('th', 'th', 2021, item)}</div>`,
    );
  });
  getNumberedArray(12).forEach(item => {
    insertElement.insertAdjacentHTML(
      'beforeend',
      `<div>${getLangFormat('id', 'id', 2021, item)}</div>`,
    );
  });
  getNumberedArray(12).forEach(item => {
    insertElement.insertAdjacentHTML(
      'beforeend',
      `<div>${getLangFormat('zh', 'hk', 2021, item)}</div>`,
    );
  });
  getNumberedArray(12).forEach(item => {
    insertElement.insertAdjacentHTML(
      'beforeend',
      `<div>${getLangFormat('vi', 'vn', 2021, item)}</div>`,
    );
  });

  getNumberedArray(12).forEach(item => console.log(getLangFormat('en', 'us', 2021, item)));
  getNumberedArray(12).forEach(item => console.log(getLangFormat('ja', 'jp', 2021, item)));
  getNumberedArray(12).forEach(item => console.log(getLangFormat('ko', 'kr', 2021, item)));
  getNumberedArray(12).forEach(item => console.log(getLangFormat('zh', 'cn', 2021, item)));
  getNumberedArray(12).forEach(item => console.log(getLangFormat('zh', 'tw', 2021, item)));
  getNumberedArray(12).forEach(item => console.log(getLangFormat('de', 'de', 2021, item)));
  getNumberedArray(12).forEach(item => console.log(getLangFormat('fr', 'fr', 2021, item)));
  getNumberedArray(12).forEach(item => console.log(getLangFormat('th', 'th', 2021, item)));
  getNumberedArray(12).forEach(item => console.log(getLangFormat('id', 'id', 2021, item)));
  getNumberedArray(12).forEach(item => console.log(getLangFormat('zh', 'hk', 2021, item)));
  getNumberedArray(12).forEach(item => console.log(getLangFormat('vi', 'vn', 2021, item)));
};
// testLangFormat();
/* eslint-enable */
